import { unlock_right } from "@/constants";
import StandardConfirmationModal from "../standard-confirmation";
import { Box } from "@mui/material";
import { FC } from "react";

interface UnblockUserModalProps extends StandardModalProps {
  onConfirm: () => void;
  name?: string;
  loading: boolean;
  description?: string;
}

const UnblockUserModal: FC<UnblockUserModalProps> = ({
  open,
  onClose,
  onConfirm,
  name,
  loading,
  description = "partner",
}) => {
  return (
    <StandardConfirmationModal
      open={open}
      onClose={onClose}
      maxWidth="xs"
      onConfirm={onConfirm}
      icon={
        <Box
          sx={{
            backgroundColor: "#E8F8EC",
            width: "48px",
            height: "48px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
          }}
        >
          <img src={unlock_right} width={20} />
        </Box>
      }
      title={`Unblock “${name}”`}
      description={`Are you sure you want to unblock this ${description}? This action cannot be undone.`}
      confirmButtonColor="success"
      confirmButtonTitle="Confirm"
      confirmButtonLoader={loading}
    />
  );
};

export default UnblockUserModal;
